
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,codeEditor,ok,err,hint,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","codeEditor","ok","err","hint","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_if = view(codeEditor("conditionals:if", {
  value: 'const myAge = 30\n\nif (myAge > 19) {\n  console.log("Ich bin kein Teenager mehr")\n}\n\nif (myAge > 29) {\n  console.log("Ich bin auch kein Tweenager mehr")\n}'
}));
return {demo_if};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_if"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_if) => {
display(consoleOutput(await runWithConsole(demo_if)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_if"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_bool = view(codeEditor("conditionals:bool", {
  value: 'console.log(4 > 2 && "a" != "b")\nconsole.log(1 != 1 && 4 >= 4)\nconsole.log(3 < 1 || 10 == 10)\nconsole.log(4 == 5 || 5 == 6)'
}));
return {demo_bool};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_bool"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithConsole,demo_bool) => {
display(consoleOutput(await runWithConsole(demo_bool)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_bool"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const demo_not = view(codeEditor("conditionals:not", {
  value: 'const age = 27\nconst isTeenager = age < 20\n\nif (!isTeenager) {\n  console.log("Kein Teenager mehr")\n}'
}));
return {demo_not};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_not"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: async (display,consoleOutput,runWithConsole,demo_not) => {
display(consoleOutput(await runWithConsole(demo_not)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_not"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_else = view(codeEditor("conditionals:else", {
  value: 'const year = 2025\nconst isSchaltjahr = year % 4 == 0\n\nif (isSchaltjahr) {\n  console.log("Schaltjahr")\n} else {\n  console.log("Kein Schaltjahr")\n}'
}));
return {demo_else};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_else"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_else) => {
display(consoleOutput(await runWithConsole(demo_else)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_else"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const demo_elseif = view(codeEditor("conditionals:elseif", {
  value: 'const age = 19\n\nif (age < 17) {\n  console.log("Darf gar kein Auto fahren")\n} else if (age < 18) {\n  console.log("Darf begleitet Auto fahren")\n} else if (age < 21) {\n  console.log("Darf alleine das eigene Auto fahren")\n} else {\n  console.log("Darf Mietwagen fahren")\n}'
}));
return {demo_elseif};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_elseif"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: async (display,consoleOutput,runWithConsole,demo_elseif) => {
display(consoleOutput(await runWithConsole(demo_elseif)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_elseif"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("conditionals:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: async (runWithConsole,uebung_code) => {
const uebungRun = await runWithConsole(uebung_code);
return {uebungRun};
},
    inputs: ["runWithConsole","uebung_code"],
    outputs: ["uebungRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (display,consoleOutput,uebungRun) => {
display(consoleOutput(uebungRun));
},
    inputs: ["display","consoleOutput","uebungRun"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: (uebung_code,display,hint,html,uebungRun,err,ok) => {
{
  const src = uebung_code;
  const declaresAll = ["birthYear", "birthMonth", "birthDay", "currentYear", "currentMonth", "currentDay"]
    .every(v => new RegExp(`\\b(let|const)\\s+${v}\\s*=`).test(src));
  const usesIf = /\bif\s*\(/.test(src);
  const usesElseIf = /\belse\s+if\b/.test(src);
  const usesAndOr = /(&&|\|\|)/.test(src);

  if (!src.trim())
    display(hint(html`Fang an, die vier Punkte umzusetzen.`));
  else if (uebungRun.error)
    display(err(html`Fehler: ${uebungRun.error}`));
  else if (!declaresAll)
    display(err(html`Lege alle 6 Eingangs-Variablen an: <code>birthYear</code>, <code>birthMonth</code>, <code>birthDay</code>, <code>currentYear</code>, <code>currentMonth</code>, <code>currentDay</code>.`));
  else if (!usesIf)
    display(err(html`Du brauchst mindestens ein <code>if</code>-Statement.`));
  else if (!usesElseIf)
    display(err(html`Für die Quartal-Logik brauchst du <code>else if</code>.`));
  else if (!usesAndOr)
    display(err(html`Für die Geschenke- und EM-Logik brauchst du <code>&&</code> oder <code>||</code>.`));
  else if (uebungRun.logs.length < 4)
    display(err(html`Du solltest 4 Werte loggen — Alter, Quartal, EM-Jahr, Geschenke. Bisher nur ${uebungRun.logs.length}.`));
  else
    display(ok(html`🎉 Übung gelöst! Fun Fact: Im Jahr 2025 das letzte mal EM und Euorpawahl in einem Jahr. Prüfe, ob dein Code das richtig erkennt und ausgibt!`));
}
},
    inputs: ["uebung_code","display","hint","html","uebungRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
